import { ref } from 'vue';
import http from '@/http.js';
import eventBus from "@/eventBus";


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useLancementFunctions = () => {
        const idJeuRequetes = ref('');
        const requetes = ref([]);
        const jeuRequetes = ref([]);
        const parametres = ref([]);
        const showModalLancement = ref(false);
        const showModalRequetesIn = ref(false);
        const loaded = ref(true);

        const showNotification = ref(false);
        const notificationMessage = ref("");
        const notificationType = ref("info");

        const handleNotification = ({ toastMessage, toastType }) => {
            notificationMessage.value = toastMessage;
            notificationType.value = toastType;
            showNotification.value = true;
            setTimeout(() => {
                showNotification.value = false;
            }, 5000);
        };

        eventBus.on("notification", handleNotification);

        const handleShowModalRequeteInJeu = (idJeuRequetes) => {
            loaded.value = false;
            http.getRequetesInJeu(idJeuRequetes).then((data) => {
                requetes.value = data;
            }).finally(() => {
                loaded.value = true;
            });
            showModalRequetesIn.value = !showModalRequetesIn.value;
        };

        const getParamsFromJeu = (idJeuRequetes) => {
            http.getParametresFromJeu(idJeuRequetes).then((data) => {
                if (data !== 0) {
                    parametres.value = data;
                    showModalLancement.value = !showModalLancement.value;
                } else {
                    eventBus.emit("notification", {
                        toastMessage: `Pas de paramètres disponibles`,
                        toastType: "danger",
                    });
                }
            });
        };

        return {
            idJeuRequetes,
            requetes,
            jeuRequetes,
            showModalRequetesIn,
            showModalLancement,
            parametres,
            getParamsFromJeu,
            loaded,
            handleShowModalRequeteInJeu,
            showNotification,
            notificationMessage,
            notificationType,
            handleNotification,
        };
};